import React, { useState } from 'react';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {
  Alert,
  Box,
  Stack, Typography,
} from '@mui/material';

import Button from '../Button';
import ContentCard from '../ContentCard';
import TextField from '../TextField';

export interface EditBreakCardProps {
  editBreak: (weeks: number) => void,
  loading?: boolean,
}

const EditBreakCard = ({
  editBreak,
  loading = false,
}: EditBreakCardProps) => {
  const [breakWeeks, setBreakWeeks] = useState(1);

  const [isForward, setIsForward] = useState(false);

  return (
    <ContentCard variant="outlined">
      <Stack direction="column" spacing={2}>
        <Stack
          justifyContent="space-between"
          direction="row"
        >
          <Typography variant="h6">Edit Break</Typography>
        </Stack>
        <Alert severity="info">
          This changes the times of this lesson and ALL subsequent lessons.
        </Alert>
        <Stack
          alignItems="flex-end"
          justifyContent="space-between"
          direction="row"
        >
          <Button
            variant="contained"
            color="backdrop"
            onClick={() => {
              editBreak(-breakWeeks);
              setIsForward(false);
            }}
            startIcon={<ArrowBackOutlinedIcon />}
            disabled={isForward && loading}
            loading={!isForward && loading}
          >
            Move earlier
          </Button>
          <Stack direction="column" alignItems="center" justifyContent="center">
            <Typography variant="body2">No. Weeks</Typography>
            <Box width={60}>
              <TextField
                value={breakWeeks}
                inputProps={{ min: 1 }}
                onChange={(e) => setBreakWeeks(parseInt(e.target.value, 10))}
                type="number"
              />
            </Box>
          </Stack>
          <Button
            variant="contained"
            color="backdrop"
            onClick={() => {
              editBreak(breakWeeks);
              setIsForward(true);
            }}
            endIcon={<ArrowForwardOutlinedIcon />}
            disabled={!isForward && loading}
            loading={isForward && loading}
          >
            Postpone
          </Button>
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default EditBreakCard;
